import { Component, EventEmitter, Output } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { IconButtonComponent } from '../../../base/icon-button/icon-button.component';

@Component({
  selector: 'spx-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  imports: [MatToolbarModule, FlexLayoutModule, IconButtonComponent],
})
export class TopbarComponent {
  @Output() toggleSidebar = new EventEmitter<void>();

  public toggle() {
    this.toggleSidebar.emit();
  }
}
